 self.onmessage = async function (event) {
    if (event.data === 'createWallet') {
      try {
        const wallet = ethers.Wallet.createRandom();
        self.postMessage(wallet);
      } catch (error) {
        self.postMessage({ error: error.message });
      }
    }
  };